import React, { useEffect, useState, createElement } from 'react';
import { TopBanner } from '../components/TopBanner';
import { HeroSectionV2 } from '../components/HeroSectionV2';
import { ProtocolPhases } from '../components/ProtocolPhases';
import { ProductInside } from '../components/ProductInside';
import { TestimonialsV2 } from '../components/TestimonialsV2';
import { TransitionSection } from '../components/TransitionSection';
import { BonusStack } from '../components/BonusStack';
import { FinalConversion } from '../components/FinalConversion';
import { OrderBump } from '../components/OrderBump';
import { FAQAccordion } from '../components/FAQAccordion';
import { TwoPathsSection } from '../components/TwoPathsSection';
import { TrustSection } from '../components/TrustSection';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function LandingPage() {
  const [isBumpSelected, setIsBumpSelected] = useState(false);
  const basePrice = 9.95;
  const bumpPrice = 4.9;
  const totalPrice = isBumpSelected ? basePrice + bumpPrice : basePrice;
  useEffect(() => {
    // Initialize Meta Pixel and fire PageView
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      // Initialize fbq function
      ;
      (window as any).fbq = function () {
        ;
        (window as any).fbq.callMethod ? (window as any).fbq.callMethod.apply((window as any).fbq, arguments) : (window as any).fbq.queue.push(arguments);
      };
      (window as any).fbq.push = (window as any).fbq;
      (window as any).fbq.loaded = true;
      (window as any).fbq.version = '2.0';
      (window as any).fbq.queue = [];
      // Load Meta Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => {
        ;
        (window as any).fbq('init', '741445578526747');
        (window as any).fbq('track', 'PageView');
      };
      document.head.appendChild(script);
    } else if (typeof window !== 'undefined' && (window as any).fbq) {
      // If fbq already exists, just track PageView
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white relative" data-id="element-376">
      <TopBanner data-id="element-377" />

      <main data-id="element-378">
        <HeroSectionV2 data-id="element-379" />
        <ProtocolPhases data-id="element-380" />
        <ProductInside data-id="element-381" />
        <TestimonialsV2 data-id="element-382" />
        <TransitionSection data-id="element-383" />
        <BonusStack data-id="element-384" />

        <div className="bg-white pt-4 pb-0 px-4" data-id="element-385">
          <OrderBump isBumpSelected={isBumpSelected} setIsBumpSelected={setIsBumpSelected} data-id="element-386" />
        </div>

        <FinalConversion totalPrice={totalPrice} isBumpSelected={isBumpSelected} data-id="element-387" />

        <FAQAccordion data-id="element-388" />
        <TwoPathsSection data-id="element-389" />
        <TrustSection data-id="element-390" />
      </main>

      <Footer data-id="element-391" />
      <StickyCTA data-id="element-392" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-393">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=741445578526747&ev=PageView&noscript=1" alt="" data-id="element-394" />
      </noscript>
    </div>;
}